<template>
  <header class="primary" :class="{mini: mini, 'is-magic-link': isMagicLinkOrScoped}">

    <v-container id="logoContainer" class="logo hidden-sm-and-down fill-height pa-0" v-if="!mini || isMagicLinkOrScoped">
      <v-layout v-if="isMagicLinkOrScoped" align-items-center justify-content-center>
        <img :src="loadedLogo" alt="Idonia Logo">
      </v-layout>
      <a v-else href="/">
        <v-layout align-items-center justify-content-center>
          <img :src="loadedLogo" alt="Idonia Logo">
        </v-layout>
      </a>
    </v-container>


    <v-toolbar class="primary elevation-0" :class="[ $theme.themes.toolbar, $vuetify.breakpoint.xsOnly ? 'mobile': '']" fixed app clipped-right>
      <!-- <iframe class="cover" src="about:blank"></iframe> -->
      <v-btn icon class="hidden-md-and-up" @click.native="$emit('back', $event)" v-if="mode === 'back'">
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <!-- Menu Button mobile -->
      <v-btn icon class="hidden-md-and-up" @click.native="$emit('menu', $event)" v-if="mode === 'back' && !searchFocus">
        <v-icon>menu</v-icon>
      </v-btn>

      <v-btn icon class="hidden-md-and-up" @click.native="$emit('menu', $event)" v-if="mode === 'menu'">
        <v-icon>menu</v-icon>
      </v-btn>


      <div id="pageTitle" class="title hidden-md-and-up" v-if="!searchFocus">
        <div v-if="navigation.length > 1">
          <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp" class="mobile-title" slot="activator" style="user-select: none;">
            <img v-if="loadedSmallLogo" :src="loadedSmallLogo" alt="Idonia Logo" class="small-logo smlogo">
            <!-- <span>{{navigation[navigation.length - 1].name}}</span> -->
          </v-toolbar-title>
        </div>

        <!-- Logo Mobile -->
        <v-toolbar-title v-else class="mobile-title" >
            <img :src="loadedSmallLogo" height="44px" alt="" class="small-logo">
            <!-- <span>{{title}}</span> -->
        </v-toolbar-title>
      </div>

      <!-- Logo -->
      <div class="logo-wrapper" v-if="!searchFocus">
        <div class="title hidden-sm-and-down" v-if="mini && !isMagicLinkOrScoped">
          <v-toolbar-title class="mobile-title">
            <a href="/">
              <img :src="loadedSmallLogo" alt="" class="small-logo">
            </a>
          </v-toolbar-title>
        </div>
      </div>

      <!-- Toolbar -->
      <v-toolbar-items class="marketing-navigation hidden-sm-and-down">
        <v-btn flat v-for="(item, n) in marketingNavigation"
               :key="n"
               @click.prevent="marketingAction(item)">
          {{item.title}}
        </v-btn>
      </v-toolbar-items>

      <!-- <v-button class="search-button" v-if="!searchEnabled" @click="searchEnabled = !searchEnabled">
        <v-icon>search</v-icon>
      </v-button> -->

      <!-- Search Results List -->
      <div class="search-wrapper" v-if="showSearchBar">

        <div v-if="$vuetify.breakpoint.smAndUp && searchEnabled">
          <search-list v-if="searchEnabled"></search-list>
        </div>

        <div class="search-button-mobile" v-if="$vuetify.breakpoint.xsOnly && searchEnabled">
          <div class="search-box">
            <search-list v-if="searchFocus" @unfocused="searchFocus = false" @focus="fromButton = false" :force-focus="fromButton"></search-list>
          </div>
          <v-btn icon v-if="!searchFocus" @click="searchFocus = true; fromButton = true"><v-icon>search</v-icon></v-btn>
        </div>
      </div>

      <v-btn
        v-if="showActionTrayDrawerMenu && !this.searchFocus"
        icon
        @click="$emit('openActionsTrayDrawer')">
        <v-icon>more_vert</v-icon>
      </v-btn>

      <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp || mode === 'none'"></v-spacer> -->
      <div class="platform-actions" v-if="$vuetify.breakpoint.mdAndUp || mode === 'none'">
        <slot name="platform-actions"></slot>
      </div>

      <v-btn v-if="$route.name === 'info-idonia'" class="hidden-sm-and-down" @click="$router.push('/v')" light><img class="pr-2" src="/static/images/magic-link-dark.svg"/>{{ $tf('Magic Link') }}</v-btn>
      <v-btn v-if="$route.name === 'info-idonia'" class="hidden-sm-and-down" @click="$router.push('/access/login')" light>{{ $tf('Access') }}</v-btn>
      <v-menu offset-y class="hidden-md-and-up" v-if="marketingNavigation.length > 0">
        <v-btn icon slot="activator">
          <v-icon>menu</v-icon>
        </v-btn>
        <v-list>
          <v-icon right>cloud_upload</v-icon>
          <v-list-tile v-for="(item, n) in marketingNavigation"
                       :key="n"
                       @click.prevent="marketingAction(item)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :key="'accessMenu'" @click="$router.push('/access/login')">
            <v-list-tile-title>{{ $tf('Access') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!--BREADBRUMBS AND ACTIONS -->
      <v-toolbar id="breadContainer" class="extension elevation-0" slot="extension" color="ext_toolbar"
                 v-if="$vuetify.breakpoint.smAndUp && (!mini || isMagicLinkOrScoped)">
        <v-container fluid class="pa-0 ma-0">
          <v-layout style="justify-content: space-between">
            <slot name="breadcrumbs"></slot>
            <slot name="local-actions"></slot>
          </v-layout>
        </v-container>
      </v-toolbar>

      <!--Only Breadcrumbs - mobile view-->
      <v-toolbar class="extension elevation-0" slot="extension" color="white"
      v-else-if="!mini || isMagicLinkOrScoped">
        <v-container fluid class="pa-0 ma-0">
          <v-layout id="breadContainer" row>
            <v-flex style="display: flex;" align-center xs12>
              <slot name="breadcrumbs"></slot>
            </v-flex>
          </v-layout>
        </v-container>
      </v-toolbar>

    </v-toolbar>
  </header>
</template>

<script>
  import SearchList from './SearchList.vue'
  import ActionsTrayDrawerMixin from '~/components/actions-tray/ActionsTray.js'
  import useLanguageTree from '~/commons/language'
  import { AllFilesFullAccessIdoniaScope } from '~/commons/scopes'

  const { getURLWithLangFallback } = useLanguageTree()

  export default {
    name: 'idonia-header',
    components: {SearchList},
    mixins: [ActionsTrayDrawerMixin],
    props: {
      whitelabel: {
        type: String,
        default: ''
      },
      logo: {
        type: String,
        default: ''
      },
      smallLogo: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: 'Idonia'
      },
      navigation: {
        type: Array,
        default: () => {
          return []
        }
      },
      marketingNavigation: {
        type: Array,
        default: () => {
          return []
        }
      },
      mode: {
        type: String,
        default: 'none'
      },
      searchEnabled: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        searchFocus: false,
        fromButton: false,
        loadedLogo: '',
        loadedSmallLogo: ''
      }
    },
    computed: {
      isMagicLinkOrScoped () {
        if (this.$route.name && this.$route.name.startsWith('public-file')) {
          return true
        }
        return this.$store.getters['session/isAuthenticated'] && !this.$store.getters['session/hasIdoniaScope'](AllFilesFullAccessIdoniaScope)
      },
      showSearchBar: function () {
        return this.$store.getters['session/isAuthenticated'] &&
          (this.$route.path.substring(1, 5) !== 'filefile' || this.$vuetify.breakpoint.smAndUp)
      }
    },
    methods: {
      marketingAction (item) {
        if (item.html === '') {
          if (window.isIE) {
            this.contactIE().catch(err => console.log('ERROR', err))
          } else {
            this.contact()
          }
          return
        }
        if (item.html.startsWith('http')) {
          window.open(item.html, '_blank')
          return
        }
        this.$router.push(this.href(item.path))
      },
      href (path) {
        let locale = this.$store.state.session.locale || 'en-US'
        return '/info/' + locale + '/' + path
      },
      async contact () {
        let url = await getURLWithLangFallback(`/static/privacy_policy/`, this.$i18n.locale, '.html')
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('web support'),
          body: require('~/components/common/dialog/types/DialogContactForm.vue').default,
          width: 720,
          persistent: false,
          props: {
            account: this.$store.state.session.account
          },
          checkbox: {
            label: this.$tf('I have read and agree to'),
            link: {
              text: this.$tf('the Privacy Policy'),
              href: url
            },
            required: true,
            value: false
          }
        })
      },
      contactIE () {
        let url = ('/static/privacy_policy/' + this.$i18n.locale + '.html')
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('web support'),
          body: require('~/components/common/dialog/types/DialogContactForm.vue').default,
          width: 720,
          persistent: false,
          props: {
            account: this.$store.state.session.account
          },
          checkbox: {
            label: this.$tf('I have read and agree to'),
            link: {
              text: this.$tf('the Privacy Policy'),
              href: url
            },
            required: true,
            value: false
          }
        })
      }
    },
    watch: {
      logo: {
        immediate: true,
        handler (val) {
          let imgWL = new Image()
          imgWL.onload = () => {
            this.loadedLogo = imgWL.src
          }
          imgWL.onerror = () => {
            let img = new Image()
            img.onload = () => {
              this.loadedLogo = img.src
            }
            img.src = val
          }
          imgWL.src = this.whitelabel + val
        }
      },
      smallLogo: {
        immediate: true,
        handler (val) {
          let imgWL = new Image()
          imgWL.onload = () => {
            this.loadedSmallLogo = imgWL.src
          }
          imgWL.onerror = () => {
            let img = new Image()
            img.onload = () => {
              this.loadedSmallLogo = img.src
            }
            img.src = val
          }
          imgWL.src = this.whitelabel + val
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  header {
    display: flex;
    justify-content: space-between;
  }

  .scrollable {
    overflow-x: auto;
    margin: 0 20px;
  }

  button img {
    width: 32px;
    height: 32px;
  }

  .search-button {
    justify-self: flex-end;
  }
  .toolbar__title /deep/ {
    margin-right: 20px;
  }

  .is-magic-link > .toolbar {
    padding-left: 300px !important;
  }

  button[disabled].btn.btn--disabled, a[disabled].btn.btn--disabled {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-bottom: 5px rgba(255, 255, 255, 0.7) solid;
  }

  .search-wrapper {
    max-width: 600px;
    flex-grow: 1;
  }
  @media screen and (min-width: 961px) and (-ms-high-contrast: none) {
    *::-ms-backdrop,  .search-wrapper {
      max-width: none;
    }
  }
  .search-button-mobile {
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    .search-box {
      flex-grow: 1;
      width: 100%;
    }
  }

  .platform-actions {
    justify-self: flex-end;
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    max-height: 36px;
    flex-grow: 1;
  }

  .small-logo {
    max-height: 64px;
  }

  .logo {
    height: 128px;
    min-width: 300px;
    max-width: 300px;
    display: flex;
    align-content: center;
    justify-content: center;
    img, object {
      max-height: 118px;
      max-width: 270px;
      margin: auto;
    }
  }

  .logo.mini {
    height: 64px;
    min-width: initial;
    max-width: 300px;
    align-content: start;
    justify-content: left;
    img, object {
      margin-left: 24px;
      max-height: 60px;
    }
  }

  .mobile-title {
    display: flex;
    align-content: center;
  }

  nav {
    transition: none !important;
  }

  #HsearchList {
    margin-top: 4px;
  }

  #logoContainer {
    position: fixed;
    margin-left: 0px;
    z-index: 5;
  }

  header > .toolbar {
    z-index: 2;
  }

  .cover {
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }

  @media only screen and (max-width: 600px) {
    .is-magic-link > .toolbar {
      padding-left: 0 !important;
    }
  }
  @media only screen and (max-width: 960px) {
    .search-wrapper {
      max-width: 960px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/IdoniaHeader.vue